import logo from './images/logo_revvy.svg';
import Logo from './images/logo_revvy.svg?react';
import IconEmployees from './images/iconEmployees.svg?react';
import IconHome from './images/iconHome.svg?react';
import IconHelp from './images/iconHelp.svg?react';
import IconLocations from './images/iconLocations.svg?react';
import IconParts from './images/iconParts.svg?react';
import IconPayouts from './images/iconPayouts.svg?react';
import IconPurchaseInventory from './images/iconPurchaseInventory.svg?react';
import IconReports from './images/iconReports.svg?react';
import IconSelling from './images/iconSelling.svg?react';
import IconSignout from './images/iconSignout.svg?react';
import IconVehicles from './images/iconVehicles.svg?react';
import bid_1 from './images/bid_1.jpg';
import bid_2 from './images/bid_2.jpg';
import bid_3 from './images/bid_3.jpg';
import bid_4 from './images/bid_4.jpg';
import bid_5 from './images/bid_5.jpg';
import bid_6 from './images/bid_6.jpg';
import bid_7 from './images/bid_7.jpg';
import starOn from './images/starOn.svg?react';
import starOff from './images/starOff.svg?react';
import iconTrash from './images/iconTrash.svg?react';
import iconTrendUp from './images/iconTrendUp.svg?react';
import iconBadgeCheck from './images/iconBadgeCheck.svg?react';
import iconBadgeUncheck from './images/iconBadgeUncheck.svg?react';
import iconClipboardCheck from './images/iconClipboardCheck.svg?react';
import iconDocumentText from './images/iconDocumentText.svg?react';
import iconKey from './images/iconKey.svg?react';
import iconPhotograph from './images/iconPhotograph.svg?react';
import iconSearchCircle from './images/iconSearchCircle.svg?react';
import iconTruck from './images/iconTruck.svg?react';
import iconChevronRight from './images/iconChevronRight.svg?react';
import iconTaskComplete from './images/iconTaskComplete.svg?react';
import iconArrowLeft from './images/iconArrowLeft.svg?react';
import iconEye from './images/iconEye.svg?react';
import iconUploadFile from './images/iconUploadFile.svg?react';
import iconQuestionMark from './images/iconQuestionMark.svg?react';
import iconCash from './images/iconCash.svg?react';

const AppImages = {
    'logo': logo,
    'Logo': Logo,
    'IconEmployees': IconEmployees,
    'IconHome': IconHome,
    'IconHelp': IconHelp,
    'IconLocations': IconLocations,
    'IconParts': IconParts,
    'IconPayouts': IconPayouts,
    'IconPurchaseInventory': IconPurchaseInventory,
    'IconReports': IconReports,
    'IconSelling': IconSelling,
    'IconSignout': IconSignout,
    'IconVehicles': IconVehicles,
    'bid_1': bid_1,
    'bid_2': bid_2,
    'bid_3': bid_3,
    'bid_4': bid_4,
    'bid_5': bid_5,
    'bid_6': bid_6,
    'bid_7': bid_7,
    'starOn': starOn,
    'starOff': starOff,
    'iconTrash': iconTrash,
    'iconBadgeCheck': iconBadgeCheck,
    'iconBadgeUncheck': iconBadgeUncheck,
    'iconDocumentText': iconDocumentText,
    'iconKey': iconKey,
    'iconPhotograph': iconPhotograph,
    'iconSearchCircle': iconSearchCircle,
    'iconTruck': iconTruck,
    'iconClipboardCheck': iconClipboardCheck,
    'iconChevronRight': iconChevronRight,
    'iconTaskComplete': iconTaskComplete,
    'iconArrowLeft': iconArrowLeft,
    'iconEye': iconEye,
    'iconUploadFile': iconUploadFile,
    'iconQuestionMark': iconQuestionMark,
    'iconTrendUp': iconTrendUp,
    'iconCash': iconCash,
}

export default AppImages;
